import type { IAddress } from "@/interfaces/IAddress"
import type { IDocument } from '@/interfaces/IDocument'
import type { IVendorUpdate } from "@/interfaces/vendors/IVendorUpdate"
import Address from "@/models/Address"
import DecoratorBase from '@/models/DecoratorBase'
import DocumentModel from "@/models/DocumentModel"

class VendorUpdate extends DecoratorBase implements IVendorUpdate {
  businessTitle: string
  
  contactName: string
  
  category?: string | null

  websiteUrl?: string | null

  phoneNumber?: string | null

  address: IAddress
  
  documents?: IDocument[]

  constructor(vendor?: any) {
    super(vendor)
    this.businessTitle = vendor?.businessTitle || ''
    this.contactName = vendor?.contactName || ''
    this.category = vendor?.category || null
    this.websiteUrl = vendor?.websiteUrl || null
    this.phoneNumber = vendor?.phoneNumber || null
    this.address = new Address(vendor?.address) || null
    this.documents = vendor?.documents?.map((document: IDocument) => new DocumentModel(document)) || []
  }
}

export default VendorUpdate
